import React from 'react'

const Shimmer = () => {
  return (
    <div className="flex flex-wrap w-[90%] mx-auto">
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
        <div className="w-80 h-80 p-4 border m-4 bg-gray-500 text-blue-100 rounded-lg"></div>
    </div>
   
  )
}

export default Shimmer
